import React, { useState, useRef, useEffect } from "react";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import PersonalProjectsTutorial from './PersonalProjectsTutorial';
import {
  Typography,
  Box,
  TextField,
  Button,
  Select,
  MenuItem,
  Card,
  Container,
  List,
  ListItem,
   CardMedia,
  CardContent,
  CardActions,
  Grid,
  Modal,
  Backdrop,
  Chip,
  Fade,
  Dialog,
  Alert,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Paper,
  CircularProgress,
  LinearProgress
} from "@mui/material";



import InfoIcon from '@mui/icons-material/Info';
import IconButton from '@mui/material/IconButton';
import useAxiosAuth from '../hooks/useAxiosAuth';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import DeleteIcon from '@mui/icons-material/Delete';
import SearchIcon from "@mui/icons-material/Search";
import MenuBookIcon from '@mui/icons-material/MenuBook';
import ErrorIcon from '@mui/icons-material/Error';
import ShoppingBagOutlinedIcon from '@mui/icons-material/ShoppingBagOutlined';
// Define the ProjectsPage component

const PersonalProjectsPage = ({  user, onInteraction}) => {

  // States for managing projects, details, and search results
 // const [projects, setProjects] = useState([]);
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [query, setQuery] = useState("");
  const [loading, setLoading] = useState(false);
  const [projectAlias, setProjectAlias] = useState("");
  const [personalProjects, setPersonalProjects] = useState([]);
  const [activePersonalProject, setActivePersonalProject] = useState({});
  const [personalQuestion, setPersonalQuestion] = useState("");
  const [currentStep, setCurrentStep] = useState(1);
  const [answer, setAnswer] = useState("");
  const [projectBlueprint, setProjectBlueprint] = useState(null);
  const [loadingBlueprint, setLoadingBlueprint] = useState(false);
  const [blueprintError, setBlueprintError] = useState("");
  const [showBlueprint, setShowBlueprint] = useState(false)
  const [selectedPersona, setSelectedPersona] = useState("");
  const [showPersonaDetails, setShowPersonaDetails] = useState(false);
  const [selectedPersonaDetails, setSelectedPersonaDetails] = useState(null);
  const [showProjectForm, setShowProjectForm] = useState(false);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [projectToDelete, setProjectToDelete] = useState(null);
  const [showCompletionNotification, setShowCompletionNotification] = useState(false);
  const [completionMessage, setCompletionMessage] = useState("");

  const [userQuestion, setUserQuestion] = useState("");
  const [followUpAnswer, setFollowUpAnswer] = useState("");
  const [followUpError, setFollowUpError] = useState("");
  const [localError] = useState("");
  const [showFollowUpQuestionBox, setShowFollowUpQuestionBox] = useState(false);
  const [openErrorDialog, setOpenErrorDialog] = useState(false);
  const [errorDialogMessage, setErrorDialogMessage] = useState("");


    // Define personas with images and descriptions
  const personas = [
 {
  id: "DIYMind",
  name: "DIYMind",
  image: "/tools.jpg",
  description: "Versatile DIY generalist with knowledge spanning multiple home improvement domains. Offers balanced advice for beginners and experienced enthusiasts alike, focusing on achievable results.",
  specialties: ["General Home Improvement", "Basic Carpentry", "Simple Repairs", "DIY Fundamentals"],
  experience: "Comprehensive expertise across various DIY disciplines with practical approaches for everyday projects"
},
 {
  id: "mecenna",
  name: "Restoration Artisan",
  image: "/restoration_artisan.jpg",
  description: "Skilled in breathing new life into vintage furniture and homes. Specializes in thoughtful restoration techniques that preserve character while enhancing functionality and comfort.",
  specialties: ["Home Renovation", "Furniture Restoration", "Interior Design", "Vintage Repurposing"],
  experience: "Expert in transforming outdated spaces and forgotten pieces into stylish, livable environments"
},
   {
  id: "houseimprovemnts",
  name: "Practical Craftsman",
  image: "/practical_craftsman.jpg",
  description: "Down-to-earth expert focusing on effective, reliable home improvement solutions with professional results. Known for clear instructions and no-nonsense approaches to construction projects.",
  specialties: ["Carpentry", "Home Renovation", "Building Techniques", "DIY Problem-Solving"],
  experience: "Specialized in efficient residential construction techniques and accessible home improvement education"
},
{
  id: "wilkerdo",
  name: "Fearless Builder",
  image: "/fearless_builder.jpg",
  description: "Bold DIY expert specializing in ambitious woodworking and metalworking projects. Approaches challenging builds with confidence and practical knowledge, focusing on durable, functional designs that push the boundaries of DIY capabilities.",
  specialties: ["Woodworking", "Metalworking", "Large-Scale Construction", "Workshop Setup", "Power Tool Mastery"],
  experience: "Advanced in creating industrial-strength projects combining multiple materials and techniques, from traditional woodworking to modern fabrication methods"
},
{
  id: "woodshopdiaries",
  name: "Everyday Woodsmith",
  image: "/everyday_woodsmith.jpg",
  description: "Approachable woodworker who transforms simple materials into beautiful, functional pieces. Makes woodworking accessible through practical techniques and clear instruction, focusing on projects that combine smart design with everyday utility.",
  specialties: ["Functional Furniture", "Storage Solutions", "Beginner-Friendly Woodworking", "Modern Farmhouse Design", "Efficient Building Methods"],
  experience: "Skilled in creating practical, stylish woodworking projects using straightforward techniques that balance quality craftsmanship with accessibility"
},
{
  id: "fixthisbuildthat",
  name: "Builder Marksman",
  image: "/builder_marksman.jpg",
  description: "Precision-focused woodworker creating functional, high-quality projects with meticulous attention to detail. Specializes in modern designs that combine clean aesthetics with smart functionality, elevating DIY projects to professional standards.",
  specialties: ["Precision Woodworking", "Space-Saving Designs", "Custom Furniture", "Smart Home Solutions", "Advanced Joinery Techniques"],
  experience: "Expert in combining traditional craftsmanship with modern techniques to create polished, durable projects that maximize both form and function"
},
{
  id: "everydayhomerepair",
  name: "House Doctor",
  image: "/house_doctor.jpg",
  description: "Practical problem-solver specializing in efficient, money-saving home repairs and maintenance. Delivers clear, no-nonsense guidance that empowers homeowners to tackle common issues with confidence and proper technique.",
  specialties: ["Plumbing Repairs", "Electrical Troubleshooting", "Drywall Patching", "Preventative Maintenance", "Cost-Effective Solutions"],
  experience: "Expert in diagnosing and fixing common household problems with straightforward methods that focus on durability and proper technique rather than temporary fixes"
}
  ];


/////////////////////////NEW
const [carouselPage, setCarouselPage] = useState(0);
const cardsPerPage = 3; // Number of cards visible at once
const totalPages = Math.ceil(personas.length / cardsPerPage);
const containerRef = useRef(null);

const nextPage = () => {
  setCarouselPage((prev) => Math.min(prev + 1, totalPages - 1));
};

const prevPage = () => {
  setCarouselPage((prev) => Math.max(prev - 1, 0));
};
  // Define theme
  const axios = useAxiosAuth();
 // console.log("PersonalProjectsPage mounted. User:", user);
  //const { user } = useAuth();
 // console.log("URL received in PersonalProjectsPage:",axios);

  const defaultHeaders = {
  'Content-Type': 'application/json'
};



const handleInteraction = (callback) => {
  if (!user) {
    onInteraction();
    return;
  }
  callback();
};


useEffect(() => {
  console.log("ProjectsPage received user:", user);
  if (user) {
 // No need to pass user
    fetchPersonalProjects();
    fetchActivePersonalProject();
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [user]);

const fetchPersonalProjects = async () => {
  if (!user) {
    setError("You must be logged in to fetch projects.");
    return;
  }

  try {
    console.log("Fetching all projects for user...");
    const response = await axios.get(`/projects/personal/all`,{ headers: defaultHeaders })
    if (response.data.projects) {
      setPersonalProjects(response.data.projects); // Update the list of projects
      console.log("Personal Projects fetched:", response.data.projects);
    } else {
      console.error("No personal projects found.");
      setPersonalProjects([]);
    }
  } catch (err) {
    console.error("Failed to fetch persoanl projects:", err);
    setError("Failed to fetch personal projects.");
  }
};

const handleViewPersonaArticles = (personaId) => {
  handleInteraction(() => {
    // Navigate to the persona's blog list page
    navigate(`/persona/${personaId}/blogs`);
  });
};

const handleAddPersonalProject = async () => {
  handleInteraction(async () => {
    if (!projectAlias.trim() || !query.trim() || !selectedPersona.trim()) {
      setError("Project alias, question prompt, and persona selection are required.");
      return;
    }
    
    // Add client-side character validation
    if (query.length > 700) {
      setError("Your personal project description must be less than 700 characters.");
      return;
    }
    //////remove pop up reminder for 10 questions
    // const confirmed = window.confirm("You'll need to answer 10 questions about your project to generate a complete blueprint. Are you ready to begin?");
    // if (!confirmed) {
    //   return;
    // }
    try {
      setLoading(true);
      await axios.post(
        "/projects/personal",
        { 
          project_alias: projectAlias, 
          project_question: query, 
          persona: selectedPersona
        },
        { headers: defaultHeaders }
      );
      setError("");
      fetchPersonalProjects();
      setShowProjectForm(false);
    } catch (err) {
      console.error("Project creation error:", err);
      // Extract the specific error message from the API response if available
      if (err.response && err.response.data && err.response.data.detail) {
        setError(err.response.data.detail);
      } else {
        setError("Failed to add personal project.");
      }
    } finally {
      setLoading(false);
    }
  });
};

const fetchNextPersonalQuestion = async (showError = true) => {
  try {

    const response = await axios.get(`/projects/personal/question`,{ headers: defaultHeaders });

    // Check if the project is complete
    if (response.data.message) {
      console.log(response.data.message);
      setPersonalQuestion("You have completed all questions for this project. Scoll up to fetch your Project Blueprint.");
      setCurrentStep(null);  // Clear the current step if needed
      return;
    }

    // Set the question and step if available
    setPersonalQuestion(response.data.question);
    setCurrentStep(response.data.step);
    setError("");  // Clear any previous errors
  } catch (err) {
    console.error("Failed to fetch next question:", err);

    if (showError) {
      setError("Failed to fetch next question.");
    }
  }
};

const fetchActivePersonalProject = async () => {
    if (!user) {
      return;
    }
    try {
      const response = await axios.get('/projects/personal/active',{ headers: defaultHeaders });
      const active = response.data.active_project?.topic;
      if (!active) {
        setActivePersonalProject(null);
        return;
      }
      setActivePersonalProject(active);
    } catch (err) {
      setError("Failed to fetch active personal project.");
    }
  };

const handleSubmitAnswer = async () => {
  handleInteraction(async () => {
    if (!answer.trim()) {
      setError("Answer is required.");
      return;
    }
    
    // Add client-side character validation
    if (answer.length > 500) {
      setError("Your answer must be less than 500 characters.");
      return;
    }
    
    try {
      const response = await axios.post(
        `/projects/personal/answer`,
        { project_alias: activePersonalProject, answer }
      );
      
      console.log("Answer submission response:", response.data);
      
      // Check if this is a completion message
      if (response.data.completed) {
        // Store the message in state
        setCompletionMessage(response.data.message || "Congratulations! You have completed all the questions. Please scroll up and fetch your project Blueprint.");
        // Show completion notification
        setShowCompletionNotification(true);
        
        // Hide notification after 10 seconds
        setTimeout(() => {
          setShowCompletionNotification(false);
        }, 10000);
      } else if (response.data.processing === true) {
        setAnswer("");
        setPersonalQuestion("Your AI Assistant is processing your intake and building your initial project outline. This may take a moment. You'll be able to answer 5 more questions once the outline is built.");
        setCurrentStep("Processing");
        
        // Start polling for the next question
        const pollForNextQuestion = () => {
          const checkInterval = setInterval(async () => {
            try {
              const nextQuestion = await axios.get(`/projects/personal/question`, { headers: defaultHeaders });
              
              // If we get a new step (11), stop polling and update UI
              if (nextQuestion.data.step && parseInt(nextQuestion.data.step) === 11) {
                clearInterval(checkInterval);
                setPersonalQuestion(nextQuestion.data.question);
                setCurrentStep(nextQuestion.data.step);
                setCompletionMessage("Initial project outline has been created! Let's continue with the final questions to refine it.");
                setShowCompletionNotification(true);
                setTimeout(() => setShowCompletionNotification(false), 8000);
              }
            } catch (err) {
              console.error("Error checking for next question:", err);
            }
          }, 3000); // Check every 3 seconds
          
          // Stop polling after 5 minutes (300 seconds) as a fallback
          setTimeout(() => {
            clearInterval(checkInterval);
            // If we're still in Processing state after timeout, show an error
            if (currentStep === "Processing") {
              setError("It's taking longer than expected. Please refresh the page or try again later.");
            }
          }, 300000);
        };
        
        pollForNextQuestion();
      }  else {
        // Normal flow - clear answer and fetch next question
        setAnswer("");
        fetchNextPersonalQuestion();
      }
    } catch (err) {
      console.error("Answer submission error:", err);
      // Extract the specific error message from the API response if available
      if (err.response && err.response.data && err.response.data.detail) {
        setError(err.response.data.detail);
      } else {
        setError("Failed to submit the answer.");
      }
    }
  });
};


const handleSetActivePersonalProject = async (projectName) => {
  handleInteraction(async () => {
    try {
      await axios.post('/projects/personal/active', { project_name: projectName },{ headers: defaultHeaders });
      setActivePersonalProject(projectName);
      console.log("Active project set successfully.");
      console.log("Active personal project set to:", projectName);
      fetchNextPersonalQuestion();
    } catch (err) {
      console.error("Failed to set active personal project:", err);
      setError("Failed to set active personal project.");
    }
  });
};

const fetchProjectBlueprint = async (projectName) => {
  try {
    setLoadingBlueprint(true);
    setBlueprintError("");
    
    // Fetch blueprint data from the backend
    const response = await axios.get(`/projects/${encodeURIComponent(projectName)}/blueprint`, { headers: defaultHeaders });
    const blueprintData = response.data.blueprint;
    
    if (blueprintData) {
      setProjectBlueprint(blueprintData);
      console.log("Fetched blueprint:", blueprintData);
      setShowBlueprint(true);
    } else {
      // Show elegant dialog instead of setting error text
      setErrorDialogMessage("No blueprint data available.");
      setOpenErrorDialog(true);
    }
  } catch (err) {
    console.error("Error fetching project blueprint:", err);
    
    // Check for the specific error message about not completing all questions
    if (err.response?.data?.detail?.includes("not completed all the questions")) {
      setErrorDialogMessage("You must complete all 15 questions before accessing your project blueprint.");
      setOpenErrorDialog(true);
    } 
    // Check for the generation error message
    else if (err.response?.data?.detail?.includes("generation error")) {
      setErrorDialogMessage("You must complete all 15 questions before accessing your project blueprint.");
      setOpenErrorDialog(true);
    } 
    else {
      // For other errors, show the specific error message
      setErrorDialogMessage(err.response?.data?.detail || "Failed to fetch project blueprint.");
      setOpenErrorDialog(true);
    }
  } finally {
    setLoadingBlueprint(false);
  }
};

// const fetchProjectBlueprint = async (projectName) => {
//   try {
//     setLoadingBlueprint(true);
//     setBlueprintError("");


//     // Fetch blueprint data from the backend
//     const response = await axios.get(`/projects/${encodeURIComponent(projectName)}/blueprint`, { headers: defaultHeaders });

//     const blueprintData = response.data.blueprint;
//     if (blueprintData) {
//       setProjectBlueprint(blueprintData);
//       console.log("Fetched blueprint:", blueprintData);
//     } else {
//       setBlueprintError("No blueprint data available.");
//     }
//   } catch (err) {
//     console.error("Error fetching project blueprint:", err);
//     setBlueprintError(err.response?.data?.detail || "Failed to fetch project blueprint.");
//   } finally {
//     setLoadingBlueprint(false);
//   }
// };

  const handlePersonaSelect = (personaId) => {
    setSelectedPersona(personaId);
    setShowProjectForm(true);
  };

  const handleShowPersonaDetails = (persona) => {
    setSelectedPersonaDetails(persona);
    setShowPersonaDetails(true);
  };

  const handleClosePersonaDetails = () => {
    setShowPersonaDetails(false);
  };

  const handleDeletePersonalProject = async (projectAlias) => {
  handleInteraction(async () => {
    try {
      await axios.delete(`/projects/personal/${encodeURIComponent(projectAlias)}`);
      
      // If the deleted project was active, clear the active project
      if (activePersonalProject === projectAlias) {
        setActivePersonalProject(null);
        setPersonalQuestion("");
        setCurrentStep(null);
      }
      
      // Refresh the projects list
      fetchPersonalProjects();
      
    } catch (err) {
      setError(`Failed to delete project: ${err.response?.data?.detail || err.message}`);
    }
  });
};


const handleFollowUpQuestion = async () => {
  handleInteraction(async () => {
    if (!activePersonalProject) {
      setFollowUpError("No active project to ask a follow-up question.");
      return;
    }
    
    if (!userQuestion.trim()) {
      setFollowUpError("Please enter your follow-up question.");
      return;
    }
    
    // Add client-side character validation
    if (userQuestion.length > 500) {
      setFollowUpError("Your question must be less than 500 characters.");
      return;
    }
    
    try {
      setLoading(true);
      setFollowUpError("");
      console.log("Sending follow-up question:", userQuestion);
      const response = await axios.post(
        '/projects/follow-up-personal-question', 
        { project_question: userQuestion },
        { headers: defaultHeaders }
      );
      console.log("Follow-up response:", response.data);
      setFollowUpAnswer(response.data.answer || "No answer available.");
      setUserQuestion("");
    } catch (err) {
      console.error("Follow-up question error:", err);
      if (err.response && err.response.data && err.response.data.detail) {
        setFollowUpError(err.response.data.detail);
      } else {
        setFollowUpError("Failed to get an answer to your follow-up question.");
      }
    } finally {
      setLoading(false);
    }
  });
};

const toggleFollowUpQuestionBox = () => {
  setShowFollowUpQuestionBox(prev => !prev);
  // Clear any previous answers when toggling
  if (!showFollowUpQuestionBox) {
    setFollowUpAnswer("");
    setFollowUpError("");
    setUserQuestion("");
  }
};


  return  (
    <Box sx={{ flexGrow: 1, p: 3 }}>
        {/* Delete Confirmation Dialog */}
<Dialog
  open={deleteConfirmOpen}
  onClose={() => setDeleteConfirmOpen(false)}
>
  <DialogTitle>Confirm Delete</DialogTitle>
  <DialogContent>
    <DialogContentText>
      Are you sure you want to delete the project "{projectToDelete}"? This action cannot be undone.
    </DialogContentText>
  </DialogContent>
  <DialogActions>
    <Button onClick={() => setDeleteConfirmOpen(false)}>Cancel</Button>
    <Button 
      onClick={() => {
        handleDeletePersonalProject(projectToDelete);
        setDeleteConfirmOpen(false);
      }} 
      color="error"
    >
      Delete
    </Button>
  </DialogActions>
</Dialog>
      <Container maxWidth="lg">
            {/* Back to Home Link - ADD THIS CODE */}
<Box sx={{ display: 'flex', mb: 4 }}>
  <Button
    startIcon={<ArrowBackIosIcon />}
    variant="text"
    onClick={() => navigate('/')}
    sx={{
      color: '#1e3c72',
      fontWeight: 500,
      '&:hover': {
        backgroundColor: 'rgba(0, 0, 0, 0.04)',
      }
    }}
  >
    Back to DIYMind Home
  </Button>
</Box>
        {/* Header */}
        <Box>
          {/* Header with animation */}
<Box
  component={motion.div}
  initial={{ opacity: 0, y: -20 }}
  animate={{ opacity: 1, y: 0 }}
  transition={{ duration: 0.5 }}
>
  <Typography 
    variant="h1" 
    gutterBottom
    sx={{
      background: 'linear-gradient(90deg, #1e3c72 0%, #2a5298 100%)',
      backgroundClip: 'text',
      textFillColor: 'transparent',
      fontWeight: 700
    }}
  >
     Your Personal Project
  </Typography>
  <Typography 
    variant="body1" 
    gutterBottom 
    sx={{ 
      mb: 4,
      maxWidth: '800px'
    }}
  >
    Choose a persona to guide your DIY project creation experience.
  </Typography>
</Box>
{/* Persona Selection Cards */}
{!showProjectForm && (
  <>
    <Typography variant="h4" gutterBottom>
      Select a Persona:
    </Typography>
    
    <Box sx={{ position: 'relative', my: 4, height: '360px', overflow: 'hidden',width: '100%' }}>
      <IconButton
        sx={{
          position: 'absolute',
          left: '10px',
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 10,
          bgcolor: 'rgba(255,255,255,0.8)',
          '&:hover': { bgcolor: 'white' },
          boxShadow: '0 4px 14px rgba(0,0,0,0.15)',
          opacity: carouselPage > 0 ? 1 : 0.3,
        }}
        onClick={prevPage}
        disabled={carouselPage === 0}
      >
        <ArrowBackIosIcon />
      </IconButton>
      <motion.div
        ref={containerRef}
        animate={{ x: `-${carouselPage * (100 / totalPages)}%` }}
        transition={{ type: 'spring', stiffness: 300, damping: 30 }}
        style={{ 
          display: 'flex', 
          width: `${Math.ceil(personas.length / cardsPerPage) * 100}%`,
          height: '100%'
        }}
      >
        {personas.map((persona, index) => (
          <Box
            key={`${persona.id}-${index}`}
            sx={{
              width: `${100 / (cardsPerPage * totalPages)}%`,
              boxSizing: 'border-box',
              padding: '0 16px'
            }}
          >
            <Card
              sx={{
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 0.3s, box-shadow 0.3s',
                '&:hover': {
                  transform: 'translateY(-8px)',
                  boxShadow: 6,
                },
                cursor: 'pointer',
                position: 'relative'
              }}
            >
              {/* Image section */}
              <CardMedia
                component="img"
                height="200"
                image={persona.image}
                alt={persona.name}
                onClick={() => handlePersonaSelect(persona.id)}
                sx={{ objectFit: 'cover' }}
              />
              
              {/* Content section - will take the space it needs */}
              <CardContent 
                onClick={() => handlePersonaSelect(persona.id)}
                sx={{ flexGrow: 0, pb: 1 }}
              >
                <Typography gutterBottom variant="h5" component="div">
                  {persona.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {persona.description.substring(0, 100)}...
                </Typography>
              </CardContent>
              
              {/* This spacer pushes the button to the bottom */}
              <Box sx={{ flexGrow: 1 }} />
              
              {/* Button section - always at the bottom */}
              <CardActions sx={{ pt: 0, pb: 2, px: 2, display: 'flex', justifyContent: 'space-between' }}>
                <Button 
                  size="small" 
                  variant="outlined"
                  startIcon={<InfoIcon />}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleShowPersonaDetails(persona);
                  }}
                >
                  Learn More
                </Button>
                
                {/* New View Articles button */}
                <Button 
                  size="small" 
                  variant="outlined"
                  startIcon={<MenuBookIcon />}
                  onClick={(e) => {
                    e.stopPropagation();
                    handleViewPersonaArticles(persona.id);
                  }}
                  color="secondary"
                >
                  Articles
                </Button>
              </CardActions>
            </Card>
          </Box>
        ))}
      </motion.div>
      <IconButton
        sx={{
          position: 'absolute',
          right: '10px',
          top: '50%',
          transform: 'translateY(-50%)',
          zIndex: 10,
          bgcolor: 'rgba(255,255,255,0.8)',
          '&:hover': { bgcolor: 'white' },
          boxShadow: '0 4px 14px rgba(0,0,0,0.15)',
          opacity: carouselPage < totalPages - 1 ? 1 : 0.3
        }}
        onClick={nextPage}
        disabled={carouselPage === totalPages - 1}
      >
        <ArrowForwardIosIcon />
      </IconButton>
      
      {/* Page indicators */}
      <Box sx={{ 
        display: 'flex', 
        justifyContent: 'center', 
        gap: 1, 
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0
      }}>
        {Array.from({ length: totalPages }).map((_, index) => (
          <Box
            key={index}
            sx={{
              width: 8,
              height: 8,
              borderRadius: '50%',
              bgcolor: index === carouselPage ? 'primary.main' : 'grey.300',
              cursor: 'pointer',
              transition: 'all 0.2s'
            }}
            onClick={() => setCarouselPage(index)}
          />
        ))}
      </Box>
    </Box>
  </>
)}

{/* Follow-Up Question Section */}
<Box sx={{ mb: 4 }}>
  {activePersonalProject && (
    <Button
      variant="outlined"
      startIcon={showFollowUpQuestionBox ? <ExpandMoreIcon /> : <SearchIcon />}
      onClick={toggleFollowUpQuestionBox}
      sx={{ 
        mb: 2,
        color: '#3f51b5',
        bgcolor: 'white',
        borderRadius: 2,
        fontWeight: 500,
        borderColor: '#3f51b5',
        '&:hover': {
          bgcolor: 'rgba(25, 118, 210, 0.04)',
          color: '#3f51b5',
        }
      }}
    >
      {showFollowUpQuestionBox ? "Hide Follow-Up Question" : "Ask Follow-Up Question"}
    </Button>
  )}
  
  {showFollowUpQuestionBox && activePersonalProject && (
    <Paper 
      elevation={2} 
      sx={{ 
        p: 3, 
        borderRadius: 2, 
        mb: 4,
        animation: 'fadeIn 0.3s ease-in-out',
        '@keyframes fadeIn': {
          '0%': { opacity: 0, transform: 'translateY(-10px)' },
          '100%': { opacity: 1, transform: 'translateY(0)' }
        }
      }}
    >
      {followUpError && (
        <Alert 
          severity="error" 
          sx={{ mb: 3, borderRadius: 2 }}
          onClose={() => setFollowUpError("")}
        >
          {followUpError}
        </Alert>
      )}
      <Typography variant="h5" gutterBottom>Ask a Follow-Up Question</Typography>
      <TextField
        fullWidth
        variant="outlined"
        placeholder="Enter your follow-up question here"
        value={userQuestion}
        onChange={(e) => {
          const value = e.target.value;
          setUserQuestion(value);
          // Clear error when user starts typing a new question
          if (followUpError) setFollowUpError("");
        }}
        error={userQuestion.length > 500}
        helperText={
          userQuestion.length > 500 
            ? `Character count: ${userQuestion.length}/500 (Exceeds limit)`
            : `Character count: ${userQuestion.length}/500`
        }
        sx={{ mb: 2 }}
      />
      
      <Button
        variant="outlined"
        onClick={() => handleInteraction(handleFollowUpQuestion)}
        disabled={!activePersonalProject || !userQuestion.trim() || loading || userQuestion.length > 500}
        sx={{ 
          mb: 2, 
          color: '#3f51b5',
          bgcolor: 'white',
          borderRadius: 2,
          fontWeight: 500,
          borderColor: '#3f51b5',
          '&:hover': {
            bgcolor: 'rgba(25, 118, 210, 0.04)',
            color: '#3f51b5',
          },
          '&.Mui-disabled': {
            color: '#3f51b5',
            opacity: 0.7,
            borderColor: '#3f51b5'
          }
        }}
      >
        Submit Question
      </Button>
      
      {followUpAnswer && (
        <Box sx={{ mt: 3, p: 3, bgcolor: '#f5f5f5', borderRadius: 1 }}>
          <Typography variant="subtitle1" color="primary" gutterBottom sx={{ fontWeight: 'bold' }}>
            Answer:
          </Typography>
          <Typography variant="body1">{followUpAnswer}</Typography>
        </Box>
      )}
      {localError && (
        <Typography variant="body2" color="error" sx={{ mt: 2 }}>
          {localError}
        </Typography>
      )}
    </Paper>
  )}
</Box>
{/* Project Creation Form - shows after persona selection */}
{showProjectForm && (
  <Box sx={{ mt: 4, p: 3, border: '1px solid #e0e0e0', borderRadius: 2, backgroundColor: '#f9f9f9' }}>
    <Typography variant="h4" gutterBottom>
      Create Project with {personas.find(p => p.id === selectedPersona)?.name || selectedPersona}
    </Typography>
    
    {/* Important notice about the 15-question process */}
    <Alert 
      severity="info" 
      sx={{ mb: 3 }}
    >
      <Typography variant="body1">
        <strong>Important:</strong> You'll need to answer 15 questions about your project to generate a complete blueprint. This step-by-step process helps our persona understand your needs and create a detailed plan.
      </Typography>
    </Alert>
    
    {/* Display error message at the top of the form if it exists */}
    {error && (
      <Alert 
        severity="error" 
        sx={{ mb: 3 }}
        onClose={() => setError("")}
      >
        {error}
      </Alert>
    )}
    <TextField
      fullWidth
      variant="outlined"
      label="Project Alias"
      placeholder="Enter a project alias"
      value={projectAlias}
      onChange={(e) => handleInteraction(() => {
        setProjectAlias(e.target.value);
        if (error) setError("");
      })}
      sx={{ mb: 3 }}
    />
    <TextField
      fullWidth
      variant="outlined"
      label="Project Question/Prompt"
      placeholder="Describe what you want to build or create"
      value={query}
      onChange={(e) => handleInteraction(() => {
        setQuery(e.target.value);
        if (error) setError("");
      })}
      multiline
      rows={4}
      error={query.length > 700}
      helperText={
        query.length > 700 
          ? `Character count: ${query.length}/700 (Exceeds limit)`
          : `Character count: ${query.length}/700`
      }
      sx={{ mb: 3 }}
    />
    
    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
      <Button 
        variant="outlined"
        onClick={() => setShowProjectForm(false)}
      >
        Back to Personas
      </Button>
      
      <Button
        variant="contained"
        color="primary"
        onClick={() => handleInteraction(handleAddPersonalProject)}
        disabled={!projectAlias.trim() || !query.trim() || loading || query.length > 700}
      >
        {loading ? "Creating..." : "Create Project"}
      </Button>
    </Box>
  </Box>
)}

          {/* Persona Details Modal */}
          <Modal
            open={showPersonaDetails}
            onClose={handleClosePersonaDetails}
            closeAfterTransition
            slots={{
              backdrop: Backdrop,
            }}
            slotProps={{
              backdrop: {
                timeout: 500,
              },
            }}
          >
            <Fade in={showPersonaDetails}>
              <Box sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: {xs: '90%', sm: '70%', md: '50%'},
                bgcolor: 'background.paper',
                borderRadius: 2,
                boxShadow: 24,
                p: 4,
              }}>
                {selectedPersonaDetails && (
                  <>
                    <Typography variant="h4" component="h2" gutterBottom>
                      {selectedPersonaDetails.name}
                    </Typography>
                    <Box sx={{ display: 'flex', flexDirection: {xs: 'column', md: 'row'}, gap: 3, mb: 3 }}>
                      <CardMedia
                        component="img"
                        sx={{ 
                          width: {xs: '100%', md: '40%'}, 
                          height: 'auto',
                          borderRadius: 1
                        }}
                        image={selectedPersonaDetails.image}
                        alt={selectedPersonaDetails.name}
                      />
                      <Box>
                        <Typography variant="body1" paragraph>
                          {selectedPersonaDetails.description}
                        </Typography>
                        <Typography variant="h6" gutterBottom>
                          Specialties:
                        </Typography>
                        <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
                          {selectedPersonaDetails.specialties.map((specialty, index) => (
                            <Chip key={index} label={specialty} color="primary" variant="outlined" />
                          ))}
                        </Box>
                        <Typography variant="body1">
                          <strong>Experience:</strong> {selectedPersonaDetails.experience}
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
                      <Button onClick={handleClosePersonaDetails} variant="outlined">
                        Close
                      </Button>
                      <Button 
                        variant="contained" 
                        color="primary"
                        onClick={() => {
                          handlePersonaSelect(selectedPersonaDetails.id);
                          handleClosePersonaDetails();
                        }}
                      >
                        Select this Persona
                      </Button>
                    </Box>
                  </>
                )}
              </Box>
            </Fade>
          </Modal>

          {/* Error Dialog */}
          <Dialog
          open={openErrorDialog}
          onClose={() => setOpenErrorDialog(false)}
          aria-labelledby="error-dialog-title"
          aria-describedby="error-dialog-description"
          PaperProps={{
           sx: {
              borderRadius: '12px',
              maxWidth: '450px',
              padding: '8px'
           }
         }}
        >
         <DialogTitle id="error-dialog-title" sx={{ 
         fontSize: '1.5rem', 
         fontWeight: 600,
         color: '#d32f2f',
         display: 'flex',
         alignItems: 'center',
         gap: 1.5
       }}>
      <ErrorIcon fontSize="large" />
       Incomplete Process
      </DialogTitle>
      <DialogContent>
      <DialogContentText id="error-dialog-description" sx={{ 
        fontSize: '1.1rem',
        color: 'text.primary',
        mt: 1
       }}>
         {errorDialogMessage || "You must complete all 15 questions before accessing your project blueprint."}
      </DialogContentText>
    
      {/* Progress visualization */}
      {currentStep && !isNaN(parseInt(currentStep)) && (
         <Box sx={{ mt: 3, mb: 2 }}>
          <Typography variant="body2" sx={{ mb: 1, fontWeight: 500 }}>
           Your progress: {currentStep}/15 questions completed
          </Typography>
          <LinearProgress 
            variant="determinate" 
            value={(parseInt(currentStep) / 15) * 100} 
            sx={{ 
              height: 10, 
              borderRadius: 5,
              backgroundColor: 'rgba(0,0,0,0.1)',
              '& .MuiLinearProgress-bar': {
                borderRadius: 5,
                backgroundColor: '#1976d2'
              }
            }}
          />
        </Box>
      )}
    
      <Box sx={{ 
        mt: 3, 
        p: 2, 
        backgroundColor: '#f5f9ff', 
        borderRadius: '8px',
        border: '1px solid #e1f5fe'
      }}>
        <Typography variant="body2" sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          gap: 1,
          color: '#0277bd',
          fontWeight: 500
        }}>
          <InfoIcon fontSize="small" />
          Next Steps:
        </Typography>
        <Typography variant="body2" sx={{ mt: 1, color: '#424242' }}>
           Please continue answering all the questions to help us build your complete project blueprint. Each question helps us understand your needs better.
        </Typography>
      </Box>
    </DialogContent>
    <DialogActions sx={{ p: 2, pt: 1 }}>
       <Button 
        onClick={() => setOpenErrorDialog(false)} 
        variant="contained"
        fullWidth
        sx={{ 
          borderRadius: '8px',
          py: 1,
          textTransform: 'none',
          fontSize: '1rem'
        }}
      >
        Continue Answering Questions
      </Button>
    </DialogActions>
  </Dialog>

          {/* Fetch & Toggle Blueprint Buttons */}
          {activePersonalProject && (
  <Box sx={{ mt: 4, mb: 2 }}>
    <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 2 }}>
      <Button
        variant="contained"
        color="primary"
        onClick={() => handleInteraction(() => fetchProjectBlueprint(activePersonalProject))}
        disabled={loadingBlueprint}
        sx={{ fontSize: '1.1rem' }}
        startIcon={<InfoIcon />}
      >
        {loadingBlueprint ? "Loading..." : "Fetch Project Blueprint"}
      </Button>
      {projectBlueprint && (
        <Button
          variant="outlined"
          color="secondary"
          onClick={() => handleInteraction(() => setShowBlueprint(!showBlueprint))}
          sx={{ fontSize: '1.1rem' }}
        >
          {showBlueprint ? "Hide Blueprint" : "Show Blueprint"}
        </Button>
      )}
    </Box>
    
    {/* Blueprint availability hint */}
    <Typography 
      variant="body2" 
      color="text.secondary" 
      sx={{ mt: 1, display: 'flex', alignItems: 'center' }}
    >
      <InfoIcon sx={{ fontSize: '1rem', mr: 0.5 }} />
      Your complete project blueprint will be available after answering all 15 questions
    </Typography>
  </Box>
)}

          {/* Display blueprint error message */}
          {blueprintError && (
            <Typography variant="body1" color="error" sx={{ marginBottom: 2, fontSize: '1.2rem' }}>
              {blueprintError}
            </Typography>
          )}

          {/* Blueprint Display */}
          {projectBlueprint && showBlueprint && (
        
            <Box
    component={motion.div}
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.5 }}
    sx={{ 
      mt: 3,
      p: 4, 
      borderRadius: '16px',
      boxShadow: '0 8px 32px rgba(0,0,0,0.08)',
      background: 'linear-gradient(to bottom, white, #f9f9f9)',
      border: '1px solid rgba(0,0,0,0.05)'
    }}
  >
              {/* Project Name */}
              <Typography variant="h4" sx={{ fontSize: '2.4rem' }} gutterBottom>
                {projectBlueprint.project_data.project_name || "Unnamed Project"}
              </Typography>
              {/* Persona Display */}
              <Typography variant="h6" sx={{ fontSize: '1.3rem' }} gutterBottom>
                Persona: {projectBlueprint.project_data.persona || "N/A"}
              </Typography>
              {/* Blueprint content remains the same as in original code */}
              
 {/* Total Cost & Time */}
      <Typography variant="h6" sx={{ fontSize: '1.3rem' }} gutterBottom>
        Total Budget: {projectBlueprint.project_data.total_budget || "N/A"}
      </Typography>
      <Typography variant="h6" sx={{ fontSize: '1.3rem' }} gutterBottom>
        Estimated Time: {projectBlueprint.project_data.total_time_estimate || "N/A"}
      </Typography>

      {/* Style */}
      <Typography variant="h6" sx={{ fontSize: '1.3rem' }} gutterBottom>
        Style: {projectBlueprint.project_data.style || "N/A"}
      </Typography>

      {/* Additional Considerations */}
      {projectBlueprint.project_data.additional_considerations && (
        <Typography variant="body1" sx={{ marginTop: 2, fontStyle: 'italic', fontSize: '1.1rem' }}>
          <strong>Additional Considerations:</strong> {projectBlueprint.project_data.additional_considerations}
        </Typography>
      )}

       {/* Processes */}
      {Array.isArray(projectBlueprint.project_data.processes) && projectBlueprint.project_data.processes.length > 0 ? (
        projectBlueprint.project_data.processes.map((process, index) => (
          <Card key={index} sx={{ marginTop: 2, padding: 3 }}>
            {/* Process Name */}
            <Typography variant="h5" sx={{ fontSize: '1.9rem' }} gutterBottom>
              {process.name || "Unnamed Process"}
            </Typography>

            {/* Process Design */}
            <Typography variant="body2" sx={{ marginBottom: 2, fontSize: '1.0rem' }}>
              <strong>Design:</strong> {process.design || "N/A"}
            </Typography>

            {/* Steps */}
            {Array.isArray(process.steps) && process.steps.length > 0 && (
              <List sx={{ paddingLeft: 2 }}>
                {process.steps.map((step) => (
                  <ListItem key={step.step_number} sx={{ display: 'block', marginBottom: 2 }}>
                    {/* Step Task */}
                    <Typography variant="body1" sx={{ fontSize: '1.1rem' }} gutterBottom>
                      <strong>Task:</strong> {step.task || "No task description available"}
                    </Typography>

                    {/* Step Description */}
                    <Typography variant="body1" sx={{ fontSize: '1.1rem' }} gutterBottom>
                      <strong>Step {step.step_number}:</strong> {step.description || "No description available"} 
                      (Time: {step.time || "N/A"}, Cost: {step.cost || "N/A"})
                    </Typography>

                    {/* Tools */}
                    {Array.isArray(step.tools) && step.tools.length > 0 && (
                      <Typography variant="body2" sx={{ marginLeft: 2, marginBottom: 1, fontSize: '1.0rem' }}>
                        <strong>Tools:</strong> {step.tools.join(", ")}
                      </Typography>
                    )}

                    {/* Materials */}
                    {Array.isArray(step.materials) && step.materials.length > 0 && (
                      <Typography variant="body2" sx={{ marginLeft: 2, marginBottom: 1, fontSize: '1.0rem' }}>
                        <strong>Materials:</strong> {step.materials.join(", ")}
                      </Typography>
                    )}
                  </ListItem>
                ))}
              </List>
            )}
          </Card>
        ))
      ) : (
        <Typography color="textSecondary" sx={{ fontSize: '1.2rem' }}>No processes available.</Typography>
      )}


{/* Products Section */}
{Array.isArray(projectBlueprint.products_data) && projectBlueprint.products_data.length > 0 && (
  <Box sx={{ marginTop: 3 }}>
    <Typography variant="h4" sx={{ fontWeight: 'bold', marginBottom: 2 }}>
      Products List:
    </Typography>
    
    <Grid container spacing={3}>
      {projectBlueprint.products_data.map((product, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Card
            component={motion.div}
            initial={{ opacity: 0, scale: 0.9 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.3, delay: index * 0.1 }}
            sx={{
              height: '100%',
              display: 'flex',
              flexDirection: 'column',
              borderRadius: '12px',
              overflow: 'hidden',
              transition: 'transform 0.3s, box-shadow 0.3s',
              '&:hover': {
                transform: 'translateY(-8px)',
                boxShadow: '0 12px 20px rgba(0,0,0,0.1)',
              },
            }}
          >
            <Box sx={{ p: 2, bgcolor: '#1e3c72', color: 'white' }}>
              <Typography variant="h6" sx={{ fontWeight: 'bold', fontSize: '1rem' }}>
                {product.type}
              </Typography>
            </Box>
            <CardContent sx={{ flexGrow: 1 }}>
              <Box sx={{ mb: 2 }}>
                <Chip
                  icon={<ShoppingBagOutlinedIcon />}
                  label={product.brand || "Brand"}
                  color="primary"
                  size="small"
                  sx={{ fontWeight: 'medium' }}
                />
              </Box>
              <Typography variant="body2" sx={{ mb: 2 }}>
                {product.description}
              </Typography>
            </CardContent>
            {product.link && (
              <CardActions>
                <Button
                  size="small"
                  color="primary"
                  href={product.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  variant="outlined"
                  fullWidth
                  startIcon={<ShoppingBagOutlinedIcon />}
                >
                  View Product
                </Button>
              </CardActions>
            )}
          </Card>
        </Grid>
      ))}
    </Grid>
  </Box>
)}
)}

            </Box>
          )}
        </Box>


 {/* Personal Projects Section */}
        <Box sx={{ marginTop: 6 }}>
          <Typography variant="h4" gutterBottom>Your Personal Projects</Typography>
          {/* Updated Dropdown to select active personal project */}
<Select
  fullWidth
  value={activePersonalProject || ""}
  onChange={(e) => handleInteraction(() => handleSetActivePersonalProject(e.target.value))}
  sx={{ marginBottom: 2 }}
  displayEmpty
>
  <MenuItem value="" disabled>Select a project</MenuItem>
  {personalProjects.map((project, index) => {
    const projectName = typeof project === 'string' ? project : project.topic || project;
    return (
      <MenuItem 
        key={`project-${index}`}
        value={projectName}
        sx={{ 
          display: 'flex', 
          justifyContent: 'space-between',
          alignItems: 'center'
        }}
      >
        <span>{projectName}</span>
        <IconButton
          size="small"
          onClick={(e) => {
            e.stopPropagation(); // Prevent select from opening
            setProjectToDelete(projectName);
            setDeleteConfirmOpen(true);
          }}
          sx={{ ml: 2 }}
        >
          <DeleteIcon color="error" />
        </IconButton>
      </MenuItem>
    );
  })}
</Select>
          
          {/* Buttons for managing personal projects */}
          <Box sx={{ marginBottom: 2, display: 'flex', gap: 2 }}>
            <Button
              variant="outlined"
              color="primary"
              onClick={() => handleInteraction(() => fetchPersonalProjects())}
            >
              Refresh Projects
            </Button>
            <Button
              variant="outlined"
              color="secondary"
              onClick={() => handleInteraction(() => {
                setSelectedPersona("");
                setShowProjectForm(true);
              })}
            >
              New Project (Any Persona)
            </Button>
          </Box>
        </Box>

{/* Personal Project Question & Answer Section - only show if active project exists */}
{activePersonalProject && (
  <Box sx={{ marginTop: 3, p: 3, border: '1px solid #e0e0e0', borderRadius: 2, backgroundColor: '#f9f9f9' }}>
    {/* Question Section Header */}
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
      <Typography variant="h5">
        {currentStep === "Processing" ? "Processing" : "Current Question"}
      </Typography>
      {currentStep && currentStep !== "Processing" && (
        <Chip 
          label={`Question ${currentStep} of 15`} 
          color="primary" 
          variant="outlined"
          sx={{ 
            fontWeight: 'medium',
            fontSize: '0.9rem',
            px: 1
          }} 
        />
      )}
      {currentStep === "Processing" && (
        <Chip 
          icon={<CircularProgress size={16} />}
          label="Processing Specifications" 
          color="secondary" 
          sx={{ 
            fontWeight: 'medium',
            fontSize: '0.9rem',
            px: 1
          }} 
        />
      )}
    </Box>
    
    {/* Question or Processing Message */}
    {personalQuestion ? (
      <Paper 
        elevation={0} 
        sx={{ 
          p: 2, 
          backgroundColor: currentStep === "Processing" ? '#fff8e1' : '#f0f7ff', 
          borderRadius: 1, 
          borderLeft: `4px solid ${currentStep === "Processing" ? '#ffc107' : '#1976d2'}`
        }}
      >
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {currentStep === "Processing" && (
            <CircularProgress 
              size={24} 
              sx={{ mr: 2, color: '#ffc107' }} 
            />
          )}
          <Typography variant="body1" gutterBottom>
            {currentStep === "Processing" ? (
              personalQuestion
            ) : (
              <><strong>Step {currentStep}:</strong> {personalQuestion}</>
            )}
          </Typography>
        </Box>
      </Paper>
    ) : (
      <Typography color="textSecondary">No question available for the current step.</Typography>
    )}
    
    {/* Display error message if exists */}
    {error && (
      <Alert 
        severity="error" 
        sx={{ my: 2 }}
        onClose={() => setError("")} 
      >
        {error}
      </Alert>
    )}
    
    {/* Answer Input - Hide when processing */}
    {currentStep !== "Processing" && (
      <>
        <TextField
          fullWidth
          variant="outlined"
          label="Your Answer"
          placeholder="Enter your answer here"
          value={answer}
          onChange={(e) => handleInteraction(() => {
            setAnswer(e.target.value);
            if (error) setError("");
          })}
          multiline
          rows={3}
          error={answer.length > 500}
          helperText={
            answer.length > 500 
              ? `Character count: ${answer.length}/500 (Exceeds limit)`
              : `Character count: ${answer.length}/500`
          }
          sx={{ marginY: 2 }}
        />
        <Button
          variant="contained"
          color="primary"
          onClick={() => handleInteraction(handleSubmitAnswer)}
          disabled={!personalQuestion || !answer.trim() || answer.length > 500}
        >
          Submit Answer
        </Button>
      </>
    )}
    
    {/* Processing state - show animated waiting element */}
    {currentStep === "Processing" && (
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center',
        py: 4 
      }}>
        <CircularProgress size={40} sx={{ mb: 2 }} />
       <Typography variant="body1" color="text.secondary" align="center">
          Processing project specifications... Question 11 coming shortly.
          </Typography>
      </Box>
    )}
    
    {/* Notification for completions and transitions */}
    {showCompletionNotification && (
      <Alert 
        severity="success" 
        sx={{ 
          mt: 2, 
          mb: 2, 
          display: 'flex', 
          alignItems: 'center',
          borderRadius: 2,
          bgcolor: '#e3f2fd', // Light blue background
          color: '#1976d2',   // Blue text
          border: '1px solid #90caf9' // Blue border
        }}
      >
        <Typography variant="body1">
          {completionMessage}
        </Typography>
      </Alert>
    )}
  </Box>
)}
      </Container>
       <PersonalProjectsTutorial />
    </Box>
  );
};

export default PersonalProjectsPage;





